import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { AnyBranchId } from '@portal-core/branches/constants/any-branch-id.constant';
import { Branch } from '@portal-core/branches/models/branch.model';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';

@CollectionStateSelectors({
  stateType: BranchesState
})
@State<BranchesState>({
  name: BranchesState.source,
})
@Service({ autoProvided: false })
export class BranchesState extends CollectionStateBase {
  static override source: string = 'Branches';

  static override readonly defaultItems: Branch[] = [{
    Id: AnyBranchId,
    ProjectId: 0,
    Name: 'Any Branch'
  }];

  override getDefaultItems(): Branch[] {
    return BranchesState.defaultItems;
  }

  getSource(): string {
    return BranchesState.source;
  }
}

@Service()
export class BranchesDataService extends CollectionDataServiceBase<Branch> {
  protected readonly stateType = BranchesState;
}
